// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__1bISw","fileBtn":"File_fileBtn__3Wdyf","closeBtn":"File_closeBtn__1UZ16","fileSelected":"File_fileSelected__33Sqh","disabled":"File_disabled__3fjTK"};